import { Card, Flex, Grid, GridItem, Separator, Text, Box, Progress, Switch, VStack, HStack } from '@chakra-ui/react';
import React from 'react';

interface ProcessingProgressSwitchProps {
    title: string;
    value?: number;
    size?: 'xs' | 'sm';
    status: 'running' | 'cancelled' | 'completed' | 'failed',
    onStatusChange: (checked: boolean) => void;
}

const ProcessingProgressSwitch = ({ 
    title = '', 
    value=0, 
    size = 'sm', 
    status,
    onStatusChange
}: ProcessingProgressSwitchProps) => {

    return (
        <Flex alignItems='center' width='100%'>
            <Switch.Root 
                size={size === 'xs' ? 'md' : 'lg'}
                checked={status === 'running'}
                onCheckedChange={(e: { checked: boolean; }) => onStatusChange(e.checked)}
            >
                <Switch.HiddenInput />
                <Switch.Control />
                <Switch.Label />
            </Switch.Root>

            <Progress.Root 
                width='100%' 
                value={value} 
                variant='subtle' 
                colorPalette='brand' 
                striped={status !== 'completed'}
                animated={status === 'running'}
                size={size}
                
            >
                <Flex alignItems='center' pb={2} gap={2}>
                    <Text color='gray.focusRing' fontSize={size}>{title} {status ?? '-'}</Text>
                    <Text fontSize={size === 'xs' ? 'md' : 'lg'}>{value} %</Text>
                </Flex>
                <Progress.Track>
                    <Progress.Range />
                </Progress.Track>
            </Progress.Root>

        </Flex>
    )
}

export default ProcessingProgressSwitch;